<template>
  <div class="home">
  
    <Reproductor  msg="Los colores" audio2="../mp3/PrimariaB/05PB.mp3" cover="../img/2.jpg" name="Primaria B - Lección #5"/>
    <Buttons/>
  </div>
</template>

<script>
// @ is an alias to /src

import Buttons from '@/components/Buttons.vue'
import Reproductor from '@/components/Reproductor.vue'
export default {
  name: 'LeccionA1',

  components: {
    Reproductor,
    Buttons,
    
  }
}
</script>
